import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { translate } from 'parking-react-common'

import { api, parkingLots } from '../redux'

import { Column } from '../components/Grid'
import Panel from '../components/Panel'
import ImageUpload from '../components/ImageUpload'

const ParkingLotPhotoView = ({ item, isEditable, isUploading, t, dispatch }) => {
    if (!item) {
        return null
    }

    const { url } = item

    return (
        <Panel title={ t('Photo') } hasTable>
            <Column span={ 4 }>
                <ImageUpload
                    url={ item.photo }
                    onChange={ isEditable ? (photo) => dispatch(parkingLots.updatePhoto({ url, photo })) : null }
                    onDelete={ isEditable ? () => dispatch(parkingLots.updatePhoto({ url, photo: null })) : null }
                    isUploading={ isUploading }
                    noImageText={ !isEditable ? t('No image selected.') : null }
                />
            </Column>
        </Panel>
    )
}

ParkingLotPhotoView.propTypes = {
    item        : PropTypes.object,
    isEditable  : PropTypes.bool,
    isUploading : PropTypes.bool
}

function mapStateToProps(state, ownProps) {
    const { item } = ownProps

    return {
        isUploading: api.isUploading(item.url)(state)
    }
}

export default compose(
    connect(mapStateToProps),
    translate()
)(ParkingLotPhotoView)
